import { Box } from '@mui/material';
import PageHeader from 'components/BaseLayout/PageHeader';
import MobileHeader from 'components/mobile/MobileHeader';
import { MonthSelector } from 'components/Shared/MonthSelector';
import { NotificationContextProvider } from 'core/providers/NotificationContextProvider';
import { getUserData } from 'core/store/actions/userData.actions';
import { periodSelector } from 'core/store/selectors/period.selector';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../core/hooks/hooks';
import { listExpenses } from '../../core/store/actions/expenses.actions';
import BudgetMonth from '../BudgetMonth/BudgetMonth';
import NotificationPanel from '../Shared/NotificationPanel';
import BudgetMonthContextProvider from './BudgetMonthContextProvider';

const BudgetMonthPage = () => {
  const dispatch = useAppDispatch();
  const budgetMonth = useAppSelector(periodSelector);

  useEffect(() => {
    dispatch(getUserData());
    dispatch(
      listExpenses({
        month: budgetMonth.month,
        year: budgetMonth.year
      })
    );
  }, []);

  return (
    <NotificationContextProvider>
      <MobileHeader>
        <MonthSelector fullWidth />
      </MobileHeader>
      <Box
        sx={{
          mt: {
            xs: '100px',
            md: 0
          },
          mb: 9
        }}
      >
        <BudgetMonthContextProvider>
          <PageHeader title="Month Budget" monthSelector />
          <BudgetMonth />
          <NotificationPanel />
        </BudgetMonthContextProvider>
      </Box>
    </NotificationContextProvider>
  );
};

export default BudgetMonthPage;
